var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('span',{staticClass:"font-mono"},[_vm._v(_vm._s(_vm.timerDisplayTime))]),_c(_vm.statusIcon,{key:_vm.extension.representativeStatus,tag:"component",staticClass:"extension-card-icon mx-2",class:{'is-calling': _vm.isCalling, 'is-talking': _vm.isTalking}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }